import { useApplicationContext } from "context/applicationContext"

const useIsWalmartUser = () => {
	const { isSupplier } = useApplicationContext()

	return !isSupplier
}

export default useIsWalmartUser
